<div class="container m-b-20">
  <mat-card>
    <form [formGroup]="clientScreenReportForm" (ngSubmit)="generate()">
      <mat-card-content>
        <div>
          <mat-form-field class="flex-fill">
            <mat-label>{{ 'labels.inputs.Client Screen Reports' | translate }}</mat-label>
            <mat-select formControlName="templateId">
              @for (template of templatesData; track template) {
                <mat-option [value]="template.id">
                  {{ template.name }}
                </mat-option>
              }
            </mat-select>
            @if (clientScreenReportForm.controls.templateId.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Screen Report' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px actions-spacing responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!clientScreenReportForm.valid">
          <fa-icon icon="cogs" size="sm" class="m-r-10"></fa-icon>{{ 'labels.buttons.Generate Report' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>

<div #output class="container m-t-20">
  <mat-card class="layout-column gap-3percent">
    <div class="layout-align-end">
      <button mat-stroked-button color="primary" [disabled]="!template" (click)="print()">
        <fa-icon icon="file" class="m-r-10"></fa-icon>
        {{ 'labels.buttons.Print' | translate }}
      </button>
    </div>

    <div #screenReport class="layout-align-center">
      <p>{{ 'labels.text.Please select a screen report.' | translate }}</p>
    </div>
  </mat-card>
</div>
